<ng-container *ngLet="{
    loading: loading$ | async,
    hasCustomFilters: hasCustomFilters$ | async
} as context">
    <ui-grid #grid
             [data]="data$ | async"
             [loading]="context.loading"
             [selectable]="!isGlobalView"
             [noDataMessage]="(isGlobalView &&
                               !context.loading &&
                               !context.hasCustomFilters &&
                               !grid.header!.searchValue
                                    ? 'no_global_robots_defined_' + (
                                        isModernFoldersEnabled
                                        ? 'modern'
                                        : 'classic'
                                    )
                                    : 'no_data_general'
                                ) | translate"
             class="ui-robots-page-grid">

        <ui-grid-header [search]="true">
            <ui-header-button type="inline">
                <ng-template>
                    <ui-grid-reset *ngIf="context.hasCustomFilters"
                                   (reset)="resetFilter()"></ui-grid-reset>
                </ng-template>
            </ui-header-button>

            <ui-header-button *ngIf="!isGlobalView"
                              type="main">
                <ng-template>
                    <ui-action-expander #expander
                                        *ngLet="(isLicenseInvalid$ | async) || !(isRobotsCreateGranted$ | async) as isExpanderDisabled"
                                        [tooltipOpen]="'grid_action_add' | translate"
                                        [tooltipClose]="'modal_action_close' | translate"
                                        [disabled]="isExpanderDisabled"
                                        [matTooltip]="isExpanderDisabled ? ('authorize_no_permissions' | translate) : ''"
                                        data-cy="robot-add">
                        <button [matTooltip]="'robots_grid_add_standard' | translate"
                                [uiAuthorizeDisable]="'Machines.View'"
                                [uiAutofocus]
                                [refocus]="expander.isActionExpanded$ | async"
                                [uiClickTrack]="'Action: Add: Standard Robot'"
                                (click)="openModal(RobotHostingType.Standard)"
                                mat-mini-fab
                                data-cy="robot-add-standard"
                                color="primary"
                                type="button">
                            <mat-icon svgIcon="uipath:standard-robot"></mat-icon>
                        </button>
                        <button [matTooltip]="'robots_grid_add_floating' | translate"
                                [uiClickTrack]="'Action: Add: Floating Robot'"
                                (click)="openModal(RobotHostingType.Floating)"
                                mat-mini-fab
                                data-cy="robot-add-floating"
                                color="primary"
                                type="button">
                            <mat-icon svgIcon="uipath:floating-robot"></mat-icon>
                        </button>
                    </ui-action-expander>
                </ng-template>
            </ui-header-button>
            <ui-header-button type="action">
                <ng-template>
                    <button [disableIf]="(loading$ | async) || hasBusyRobotsSelected"
                            [uiAuthorize]="'Robots.Delete'"
                            [matTooltip]="'robots_grid_action_remove' | translate"
                            (click)="onRemoveItems()"
                            mat-icon-button
                            color="warn"
                            type="button">
                        <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                    </button>
                </ng-template>
            </ui-header-button>
        </ui-grid-header>

        <ui-grid-column *ngIf="!isGlobalView"
                        [searchable]="true"
                        [sortable]="true"
                        [primary]="true"
                        [title]="'robots_grid_name' | translate"
                        property="robot.name"
                        width="15%">
            <ng-template let-entry="data">
                <ng-container *ngTemplateOutlet="status;  context: { $implicit: entry }"></ng-container>

                <span [matTooltip]="entry.robot.name">
                    {{ entry.robot.name }}
                </span>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column *ngIf="isGlobalView"
                        [searchable]="true"
                        [sortable]="true"
                        [title]="'robots_grid_username' | translate"
                        [refetch]="refetchMap.userName"
                        property="robot.userName"
                        width="30%">
            <ng-template let-entry="data">
                <ng-container *ngTemplateOutlet="status; context: { $implicit: entry }"></ng-container>
                <ng-container *ngTemplateOutlet="userNameColumn; context: { $implicit: entry }"></ng-container>

            </ng-template>
            <ui-grid-search-filter [searchSourceFactory]="userNameSuggest"
                                   [disabled]="!(isRobotsViewGranted$ | async)"
                                   property="robot.userName">
            </ui-grid-search-filter>
        </ui-grid-column>

        <ui-grid-column [searchable]="true"
                        [sortable]="true"
                        [title]="'robots_grid_machine' | translate"
                        [refetch]="refetchMap.machineName"
                        property="hostMachineName"
                        width="22%">
            <ui-grid-search-filter [searchSourceFactory]="machineNameSuggest"
                                   [disabled]="!(isMachinesViewGranted$ | async)"
                                   property="machineId">
            </ui-grid-search-filter>
            <ng-template let-entry="data">
                <ng-container *ngLet=" entry.licenseErrorCode !== LicenseErrorCode[LicenseErrorCode.RuntimeDisabled] ?
                                       entry.hostMachineName :
                                       ('machine_is_disabled' | translate: {
                                           machine: entry.hostMachineName,
                                           licenseType: entry.robot.type
                                   }) as typeTooltip">
                    <span [class.strikethrough]="entry.licenseErrorCode === LicenseErrorCode[LicenseErrorCode.RuntimeDisabled]"
                          [matTooltip]="typeTooltip">
                        {{ entry.hostMachineName }}
                        <ng-container *ngIf="entry.robot.hostingType === RobotHostingType.Floating &&
                               entry.machineName">
                            ({{ entry.machineName }})
                        </ng-container>
                    </span>
                </ng-container>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column *ngIf="isGlobalView"
                        [sortable]="true"
                        [title]="'robots_grid_provision_type' | translate"
                        property="robot.provisionType"
                        width="10%">
            <ng-template let-entry="data">
                <span translate>{{
               entry.robot.provisionType === RobotProvisionType.Automatic
                           ? 'FolderType_Modern'
                           : 'FolderType_Classic'
            }}</span>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column *ngIf="!isGlobalView"
                        [searchable]="true"
                        [sortable]="true"
                        [title]="'robots_grid_username' | translate"
                        [refetch]="refetchMap.userName"
                        property="robot.userName"
                        width="25%">
            <ng-template let-entry="data">
                <ng-container *ngTemplateOutlet="userNameColumn; context: { $implicit: entry }"></ng-container>
            </ng-template>
            <ui-grid-search-filter [searchSourceFactory]="userNameSuggest"
                                   [disabled]="!(isRobotsViewGranted$ | async)"
                                   property="robot.userName">
            </ui-grid-search-filter>
        </ui-grid-column>

        <ui-grid-column [sortable]="true"
                        [primary]="true"
                        [title]="'robots_grid_license_type' | translate"
                        property="robot.type"
                        width="18%">
            <ui-grid-dropdown-filter [items]="typeList"></ui-grid-dropdown-filter>
            <ng-template let-entry="data">
                <ng-container *ngIf="isFrontOffice(entry.robot.type) && entry.state !== 'Disconnected';">
                    <mat-icon *ngIf="entry.robot?.license != null"
                              [matTooltip]="'robot_grid_license_acquired_on' | translate:{
                                        datetime: formatRobotAcquiredOnDate(entry.robot.license.timestamp)
                                    }"
                              class="license-icon license-icon-green">fiber_manual_record</mat-icon>
                    <mat-icon *ngIf="entry.robot?.license == null"
                              [matTooltip]="'LicensedStatus_Red' | translate"
                              class="license-icon license-icon-red">fiber_manual_record</mat-icon>
                </ng-container>
                <ng-container *ngLet="('RobotType_' +
                                   (
                                       entry.robot.hostingType === RobotHostingType.Floating ?
                                           RobotType[entry.robot.type] + 'Floating':
                                           RobotType[entry.robot.type]
                                   ) | translate) as robotTypeText">
                    <span [matTooltip]="robotTypeText">{{ robotTypeText }}</span>
                </ng-container>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column [visible]="false"
                        [title]="'robots_grid_hosting_type' | translate"
                        property="robot.hostingType">
            <ui-grid-dropdown-filter [items]="hostingTypeList"></ui-grid-dropdown-filter>
        </ui-grid-column>

        <ui-grid-column *ngIf="!isGlobalView"
                        [title]="'robots_grid_environments' | translate"
                        property="robot.robotEnvironments"
                        width="20%">
            <ui-grid-search-filter [searchSourceFactory]="environmentNameSuggest"
                                   [disabled]="!(isEnvironmentsViewGranted$ | async)"
                                   property="robot.environments.id">
            </ui-grid-search-filter>
        </ui-grid-column>

        <ui-grid-column [primary]="true"
                        [sortable]="true"
                        [title]="'robots_grid_status' | translate"
                        property="state"
                        width="15%"
                        sort="asc">
            <ui-grid-dropdown-filter [items]="stateList"></ui-grid-dropdown-filter>
            <ng-template let-entry="data">
                <span *ngLet="('RobotState_' + entry.computedState | translate) as stateText"
                      [matTooltip]="stateText + ' @ ' + formatRobotAcquiredOnDate(entry.reportingTime)">
                    {{ stateText }}
                </span>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column *ngIf="isGlobalView"
                        [title]="'robots_grid_folder' | translate"
                        property="folder"
                        width="10%">
            <ng-template let-entry="data">
                <span *ngIf="entry.robot.provisionType === RobotProvisionType.Manual; else checkPermissionsTpl">
                    {{ entry.folder }}
                </span>
                <ng-template #checkPermissionsTpl>
                    <button *ngLet="userIdLoading$ | async as userIdLoading"
                            [uiClickTrack]="'Action: Grid: Check Permissions'"
                            [spinnerButtonLoading]="userIdLoading === entry.robot.userId"
                            [disableIf]="userIdLoading != null"
                            [uiAuthorizeAllDisable]="['Units.View', 'Users.View', 'Roles.View']"
                            [matTooltip]="'robots_grid_folder_check' | translate"
                            (click)="checkPermissions(entry.robot.userId)"
                            ui-spinner-button
                            mat-icon-button
                            data-cy="robot-check-permissions"
                            type="button">
                        <mat-icon>security</mat-icon>
                    </button>
                </ng-template>
            </ng-template>
        </ui-grid-column>

        <ui-grid-row-action>
            <ng-template let-index="index"
                         let-entry="data">
                <ng-container *ngIf="entry.robot?.id && !isGlobalView">
                    <button [matMenuTriggerFor]="menu"
                            [uiAuthorizeAnyDisable]="['Logs.View', 'Robots.Create', 'Robots.Delete', 'Monitoring.View']"
                            [matTooltip]="'global_more_actions_tooltip' | translate"
                            mat-icon-button
                            data-cy="grid-action-menu"
                            type="button">
                        <mat-icon svgIcon="uipath:More"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button [uiAuthorizeDisable]="'Robots.Edit'"
                                [disableIf]="isLicenseInvalid$ | async"
                                [uiClickTrack]="'Action: Grid: Edit'"
                                (click)="openModal(entry.robot.hostingType, entry)"
                                mat-menu-item
                                data-cy="robot-edit"
                                type="button">
                            <mat-icon svgIcon="uipath:Edit"></mat-icon>
                            <span>{{ 'robots_grid_action_edit' | translate }}</span>
                        </button>
                        <a [routerLink]="['/robots', entry.robot?.id, 'logs']"
                           [uiAuthorize]="'Logs.View'"
                           mat-menu-item>
                            <mat-icon>notes</mat-icon>
                            <span>{{'robots_grid_action_view_logs' | translate}}</span>
                        </a>
                        <button [disableIf]="isLicenseInvalid$ | async"
                                [uiAuthorize]="'Robots.Create'"
                                [uiClickTrack]="'Action: Grid: Duplicate'"
                                (click)="openModal(entry.robot.hostingType, entry, true)"
                                mat-menu-item
                                data-cy="robot-duplicate"
                                type="button">
                            <mat-icon svgIcon="uipath:Duplicate"></mat-icon>
                            <span>{{'robots_grid_action_duplicate' | translate}}</span>
                        </button>
                        <button [hidden]="!isConvertibleToFloating(entry.robot)"
                                [disableIf]="!isConvertibleToFloating(entry.robot)"
                                [uiAuthorize]="'Robots.Edit'"
                                [uiClickTrack]="'Action: Grid: Convert to Floating'"
                                (click)="convertToFloating(entry.robot)"
                                mat-menu-item
                                data-cy="robot-convert-floating"
                                type="button">
                            <mat-icon svgIcon="uipath:floating-robot"></mat-icon>
                            <span>{{ 'robot_modal_action_convert_to_floating' | translate}}</span>
                        </button>
                        <!--
                       using *ngIf affects order for keyboard nav [a11y]
                       TODO: remove if fix is merged
                       https://github.com/angular/material2/pull/11720
                    -->
                        <button [disableIf]="!isMonitoringEnabled"
                                [routerLink]="['/monitoring/robots/', entry.robot.id]"
                                [uiAuthorize]="'Monitoring.View'"
                                [uiClickTrack]="'Action: Grid: Monitor Robot'"
                                mat-menu-item
                                data-cy="robot-monitor"
                                type="button">
                            <mat-icon>insert_chart</mat-icon>
                            <span translate>robots_grid_action_monitor</span>
                        </button>
                        <button [disableIf]="entry.state === 'Busy' || (loading$ | async)"
                                [uiAuthorize]="'Robots.Delete'"
                                [uiClickTrack]="'Action: Grid: Remove'"
                                (click)="onRemoveItems([entry])"
                                mat-menu-item
                                color="warn"
                                data-cy="robot-remove"
                                type="button">
                            <mat-icon svgIcon="uipath:Delete"></mat-icon>
                            <span>{{'robots_grid_action_remove' | translate}}</span>
                        </button>
                    </mat-menu>
                </ng-container>
            </ng-template>
        </ui-grid-row-action>

        <ui-grid-footer [length]="total$ | async"
                        [pageSize]="pageSize"
                        [pageSizes]="pageSizes">
        </ui-grid-footer>

    </ui-grid>

    <ng-template #status
                 let-entry>
        <mat-icon *ngIf="entry.state === 'Disconnected'; else notDisconnected"
                  svgIcon="uipath:StatusCanceling"></mat-icon>
        <ng-template #notDisconnected>
            <mat-icon *ngIf="entry.isUnresponsive; else responding"
                      svgIcon="uipath:StatusWarning"></mat-icon>
            <ng-template #responding>
                <mat-icon *ngIf="entry.state === 'Busy'; else statusOK"
                          svgIcon="uipath:StatusPlay"></mat-icon>
                <ng-template #statusOK>
                    <mat-icon svgIcon="uipath:StatusOK"
                              color="success"></mat-icon>
                </ng-template>
            </ng-template>
        </ng-template>
    </ng-template>

    <ng-template #userNameColumn
                 let-entry>
        <span [matTooltip]="entry.robot.userName">{{ entry.robot.userName }}</span>
    </ng-template>
</ng-container>
